import React from 'react';
import './header.css';

const navItems = [
  { label: 'About Us', target: 'about' },
  { label: 'Our Services', target: 'services' },
  { label: 'Our Products', target: 'products' },
  { label: 'Contact Us', target: 'contact' },
];

function Header({ onNavigate }) {
  return (
    <header className='header'>
      <div className='headerInner'>
        <button type='button' className='brand' onClick={() => onNavigate('top')} aria-label='Viewjot home'>
          <img className='headerlogo' src={'/ViewJot-logo.png'} alt='Viewjot logo' />
        </button>

        <nav className='headermenu' aria-label='Main navigation'>
          {navItems.map((item) => (
            <button key={item.label} type='button' className='menuLink' onClick={() => onNavigate(item.target)}>
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;